import {HttpErrorResponse} from '@angular/common/http';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class LoginState extends LoadableState {
  public static readonly key = 'LoginState';

  @autoserializeAs('error')
  public error: HttpErrorResponse = null;
}
